export default __webpack_public_path__ + "static/assets/Shelf-Life_X_White.82dbbe52.png";